import { useState, useCallback, useEffect } from 'react'
import eventBus from '../../../../../../services/eventBus'
import equipmentApi from '../../../../equipment.api'
import { TEquipmentMaintenanceBlankType, IEquipment, IEquipmentMaintenanceBlank } from '../../../../equipment.types'

export interface IEquipmentMaintenanceFiltersState {
  type: TEquipmentMaintenanceBlankType
  created_lte: Date
  created_gte: Date
  search: string
}

const useEquipmentMaintenanceTableCtrl = (equipmentId: IEquipment['id']) => {
  const [filters, setFilters] = useState<IEquipmentMaintenanceFiltersState>({
    type: null,
    created_gte: null,
    created_lte: null,
    search: '',
  })
  const [timelineKey, setTimelineKey] = useState(0)
  const [items, setItems] = useState<IEquipmentMaintenanceBlank[]>([])

  const dataLoad = useCallback(
    (params: any) => {
      return equipmentApi.getMaintenanceHistory(equipmentId, {
        page: params['page'],
        search: filters.search,
        type: filters.type,
        created_lte: filters.created_lte ? filters.created_lte.toISOString() : null,
        created_gte: filters.created_gte ? filters.created_gte.toISOString() : null,
      })
    },
    [equipmentId, filters.created_gte, filters.created_lte, filters.search, filters.type]
  )

  useEffect(() => {
    const unsub = eventBus.sub('equipment.maintenance.blank.created', (blank) => {
      setItems((prev) => [blank, ...prev])
    })

    return () => {
      unsub()
    }
  }, [])

  const handleFilterChange = <T extends keyof IEquipmentMaintenanceFiltersState>(
    value: IEquipmentMaintenanceFiltersState[T],
    key: T
  ) => {
    setFilters((prev) => ({ ...prev, [key]: value }))
  }

  const handleDate = (startTs: number, endTs: number) => {
    handleFilterChange(startTs ? new Date(startTs) : null, 'created_gte')
    handleFilterChange(endTs ? new Date(endTs) : null, 'created_lte')
  }

  return {
    data: {
      timelineKey,
      items,
      filters,
    },
    handlers: {
      handleFilterChange,
      dataLoad,
      incrementTimelineKey: () => setTimelineKey((prev) => prev + 1),
      setItems,
      handleDate,
    },
  }
}

export default useEquipmentMaintenanceTableCtrl
